exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.item-info[data-v-3cdf4648] {\n  float:left;\n  width:30px;\n  height:30px;\n  margin-left:8px\n}\n.item-img[data-v-3cdf4648] {\n  cursor:pointer;\n  position: static;\n  display: block;\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n", ""]);

// exports
